import React from 'react'
import s from './ReviewsSmall.module.css'
import { useTranslations } from 'next-intl'
import { Rating } from '@components/ui'

export interface ReviewsSmallProps {
  className: string
  rating: any
  reviewers: any
  recommended: any
}

const ReviewsSmall: React.FC<ReviewsSmallProps> = ((props) => {
  const {
    className,
    rating,
    reviewers,
    recommended
  } = props

  const t = useTranslations('Global')

  // @ts-ignore
  return (
    <div className={s.root}>
      <div className={'mx-auto border-neutral400 border-b border-solid max-w-e591' + (className === 'product' ? '' : 'text-center') + ' text-neutral900'}>
        {className === 'product' && <div className={'mb-space4'}>
          <div className={'block px-space6 md:px-space16 text-center'}>
            <p className={'text-heading01 pt-space2 md:pt-space6 block'}>{rating}</p>
            <p className={'block py-0'}><Rating value={rating} /></p>
            <p
              className={'text-button w-e336 text-neutral700 font-mono inline-block'}>[{reviewers} {t('reviewers')} / {recommended}% {t('userRecommendedProduct')}]</p>
          </div>
        </div>
        }
      </div>

    </div>
  )
})

export default ReviewsSmall
